<template>
  <div>
    <NavbarAdmin/>  
    <HelloWorld/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import NavbarAdmin from '@/components/NavbarAdmin'

export default {
  name: 'App',
  components: {
    HelloWorld,
    NavbarAdmin
  },
  setup() {
 
  },
};
  
</script>

